import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-product-list',
  template: `
    <div class="bg-gray-50 rounded-lg p-4 my-3">
      <div *ngIf="data && data.length" class="grid grid-cols-1 md:grid-cols-2 gap-3">
        <div *ngFor="let product of data"
             class="bg-white rounded-lg shadow hover:shadow-md transition-shadow duration-200 overflow-hidden flex flex-row">
          <!-- Image side -->
          <div class="w-24 h-24 flex-shrink-0 flex items-center justify-center p-2 bg-gray-100">
            <img [src]="product.imageUrl || 'assets/images/placeholder.png'"
                 [alt]="product.name"
                 class="max-h-full max-w-full object-contain">
          </div>
          <!-- Product details side -->
          <div class="p-3 flex-grow flex flex-col justify-between">
            <h4 class="text-sm font-medium text-gray-800 line-clamp-2">
              {{ product.name }}
            </h4>
            <h4 class="text-sm font-medium text-gray-800 line-clamp-2">
              {{ product.sku }}
            </h4>
            <div class="text-[#FF6D03] font-semibold mt-2">
              {{ product.defaultPrice | currency:'USD':'symbol':'1.0-2' }}
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="!data || !data.length" class="text-center text-gray-500 py-4">
        No hay productos para mostrar
      </div>
    </div>
  `
})
export class ProductListComponent implements OnInit {
  @Input() data: any[] = [];

  constructor() { }

  ngOnInit(): void {
    console.log('Product list data:', this.data);
  }
}
